import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { DailyReportDTO } from '../types/daily-report-dto.model';

@Injectable({
  providedIn: 'root',
})
export class DataService {
  constructor(private httpClient: HttpClient) {}

  getOSP(ospId: string) {
    const headers = new HttpHeaders().set(
      'API-Key',
      environment.apiKey
    ); 

    const params = new URLSearchParams();
    params.set('ospId', ospId);

    const result = this.httpClient.get(
      `${environment.baseAPIUrl}/qb/osp?${params.toString()}`,
      { headers }
    );
    return result;
  }

  getContractPartners(
    assignmentCPName: string,
    clientAndProject: string
  ) {
    const headers = new HttpHeaders().set(
      'API-Key',
      environment.apiKey
    ); 

    const params = new URLSearchParams();
    params.set('client-and-project', clientAndProject);
    params.set('contract-partners', assignmentCPName);

    const result = this.httpClient.get(
      `${environment.baseAPIUrl}/qb/contract-partners?${params.toString()}`,
      { headers }
    );
    return result;
  }

  getBillingCodes(
    relatedProject: string,
    relatedClient: string,
    contractPartnerName: string
  ) {
    const headers = new HttpHeaders().set(
      'API-Key',
      environment.apiKey
    ); 

    const params = new URLSearchParams();
    params.set('related-project', relatedProject);
    params.set('related-client', relatedClient);
    params.set('contract-partners', contractPartnerName);

    const result = this.httpClient.get(
      `${environment.baseAPIUrl}/qb/billing-codes?${params.toString()}`,
      { headers }
    );
    return result;
  }

  getCPBillingCodes(
    relatedProject: string,
    relatedClient: string,
    contractPartnerName: string
  ) {
    const headers = new HttpHeaders().set(
      'API-Key',
      environment.apiKey
    ); 
    
    const params = new URLSearchParams();
    params.set('related-project', relatedProject);
    params.set('related-client', relatedClient);
    params.set('contract-partner', contractPartnerName);
    
    const result = this.httpClient.get(
      `${environment.baseAPIUrl}/qb/cp-billing-codes?${params.toString()}`,
      { headers }
    );
    return result;
  }

  getDailyReports(ospId: string) {
    const headers = new HttpHeaders().set(
      'API-Key',
      environment.apiKey
    ); 

    const params = new URLSearchParams();
    params.set('ospId', ospId);

    const result = this.httpClient.get(
      `${environment.baseAPIUrl}/qb/daily-reports?${params.toString()}`,
      { headers }
    );
    return result;
  }
  
  postDailyReport(ospId: string | number, data: DailyReportDTO) {
    let headers = new HttpHeaders().set(
      'API-Key',
      environment.apiKey
    ); 
    headers = headers.set('Content-Type', 'application/json');
    const result = this.httpClient.post(
      `${environment.baseAPIUrl}/daily-importer/${ospId}`,
      JSON.stringify([data]),
      { headers }
    );
    return result;
  }

  postDailyReportV3(ospId: number, data: DailyReportDTO) {
    let headers = new HttpHeaders().set(
      'API-Key',
      environment.apiKey
    ); 
    headers = headers.set('Content-Type', 'application/json');
    const result = this.httpClient.post(
      `${environment.baseAPIUrl}/daily-importer/${ospId}`,
      JSON.stringify([data]),
      { headers }
    );
    return result;
  }

  getCpOspData(guid: string) {
    let headers = new HttpHeaders().set(
      'API-Key',
      environment.apiKey
    ); 
    const result = this.httpClient.get(
      `${environment.baseAPIUrl}/qb/cp-osp/${guid}`,
      { headers }
    );
    return result;
  }

  getCrews(cpId: number) {
    let headers = new HttpHeaders().set(
      'API-Key',
      environment.apiKey
    ); 
    const result = this.httpClient.get(
      `${environment.baseAPIUrl}/qb/crews?cp-id=${cpId}`,
      { headers }
    );
    return result;
  }
/**
 * Returns list of crews.
 * @param guid CP Guid.
 * @returns list of crews for cp.
 */
  getCrewsByGuid(guid: string) {
    let headers = new HttpHeaders().set(
      'API-Key',
      environment.apiKey
    ); 
    const result = this.httpClient.get(
      `${environment.baseAPIUrl}/qb/job-switcher/crews/${guid}`,
      { headers }
    );
    return result;
  }

/**
 * Returns list of related osps.
 * @param guid CP Guid.
 * @returns list of osps related to cp.
 */
  getOspListByGuid(guid: string) {
    let headers = new HttpHeaders().set(
      'API-Key',
      environment.apiKey
    ); 
    const result = this.httpClient.get(
      `${environment.baseAPIUrl}/qb/job-switcher/osp-list/${guid}`,
      { headers }
    );
    return result;
  }

  /**
   * Returns list of submitted daily reports filtered by cp guid for specific osp.
   * @param guid CP Guid.
   * @param ospId OSP ID.
   * @returns list of daily reports.
   */
  getDRByGuid(guid: string, ospId: string | number) {
    let headers = new HttpHeaders().set(
      'API-Key',
      environment.apiKey
    ); 
    const result = this.httpClient.get(
      `${environment.baseAPIUrl}/qb/job-switcher/daily-reports/${guid}?ospId=${ospId}`,
      { headers }
    );
    return result;
  }

  /**
   * Returns billing codes for specific osp and cp.
   * @param guid CP Guid.
   * @param ospId OSP ID.
   * @returns list of billing codes.
   */
  getBillingCodesByGuid(guid: string, ospId: string | number) {
    let headers = new HttpHeaders().set(
      'API-Key',
      environment.apiKey
    ); 
    const result = this.httpClient.get(
      `${environment.baseAPIUrl}/qb/job-switcher/cp-billing-codes/${guid}?ospId=${ospId}`,
      { headers }
    );
    return result;
  }

  getTasksByGuid(guid: string, ospId: string | number) {
    let headers = new HttpHeaders().set(
      'API-Key',
      environment.apiKey
    );
    const result = this.httpClient.get(
      `${environment.baseAPIUrl}/qb/job-switcher/cp-tasks/${guid}?ospId=${ospId}`,
      { headers }
    );
    return result;
  }

  getCPDataByGuid(guid: string) {
    let headers = new HttpHeaders().set(
      'API-Key',
      environment.apiKey
    ); 
    const result = this.httpClient.get(
      `${environment.baseAPIUrl}/qb/job-switcher/contract-partner/${guid}`,
      { headers }
    );
    return result;
  }

  getOspFiles(guid: string, ospId: string | number) {
    let headers = new HttpHeaders().set(
      'API-Key',
      environment.apiKey
    ); 
    const result = this.httpClient.get(
      `${environment.baseAPIUrl}/qb/job-switcher/osp-files/${guid}?ospId=${ospId}`,
      { headers }
    );
    return result;
  }

  /**
   * LH-51: Returns the render-ready Contract Partner Purchase Order for one job.
   * The backend derives the CP OSP Assignment server-side from guid + ospId and
   * reproduces the "Generate CP PO" code page's rules, so no QuickBase token and
   * no field ids ever reach the partner's browser.
   *
   * @param guid CP Guid.
   * @param ospId OSP ID.
   * @returns purchase order payload (see LH-51 API contract).
   */
  getCpPo(guid: string, ospId: string | number) {
    const headers = new HttpHeaders().set(
      'API-Key',
      environment.apiKey
    );
    const result = this.httpClient.get(
      `${environment.baseAPIUrl}/qb/job-switcher/cp-po/${guid}?ospId=${ospId}`,
      { headers }
    );
    return result;
  }

  getDRFiles(guid: string, ospId: string | number) {
    let headers = new HttpHeaders().set(
      'API-Key',
      environment.apiKey
    ); 
    const result = this.httpClient.get(
      `${environment.baseAPIUrl}/qb/job-switcher/daily-report-files/${guid}?drId=${ospId}`,
      { headers }
    );
    return result;
  }

  postFile(ospId: string | number,files) {
    let headers = new HttpHeaders().set(
      'API-Key',
      environment.apiKey
    ); 
    const result = this.httpClient.post(
      `${environment.baseAPIUrl}/upload_files/${ospId}`,
      files,
      { headers }
    );
    return result;
  }

  postFileOSPGuid(guid: string, files) {
    let headers = new HttpHeaders().set(
      'API-Key',
      environment.apiKey
    ); 
    const result = this.httpClient.post(
      `${environment.baseAPIUrl}/file_uploader/${guid}`,
      files,
      { headers }
    );
    return result;
  }

  getFilesOspGuid(guid: string) {
    let headers = new HttpHeaders().set(
      'API-Key',
      environment.apiKey
    ); 
    const result = this.httpClient.get(
      `${environment.baseAPIUrl}/file_uploader/${guid}`,
      { headers }
    );
    return result;
  }

  /**
   * LH-35: File Uploader categories, read from the choices of the Quickbase
   * File Attachments "Category" field so the picker matches the list in LHC.
   */
  getFileCategories() {
    let headers = new HttpHeaders().set(
      'API-Key',
      environment.apiKey
    );
    return this.httpClient.get<string[]>(
      `${environment.baseAPIUrl}/file_uploader/categories`,
      { headers }
    );
  }
}
